<template>
  <v-app>
    <v-row class="locale">
      <v-col>
        <switch-locale></switch-locale>
      </v-col>
    </v-row>
    <div class="login-header">
      <v-row>
        <v-col class="pt-5">
          <img src="@/assets/logo.svg" height="50" alt="logo" />
        </v-col>
      </v-row>
    </div>
    <div class="main">
      <div class="login-form">
        <div class="welcome-text">

          <div class="nf">404 </div>
          <h1>Page not found</h1>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import SwitchLocale from "@/components/SwitchLocale";

export default {
  data: () => ({}),

  methods: {},

  computed: {},

  components: {
    SwitchLocale,
  },
};
</script>

<style scoped>
.nf{
  color: #7b766a;
  font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  font-size: 164px;
}
.login-header {
  margin: 0px auto;
  background-color: #fff;
  display: inline-flex;
}

.locale {
  position: absolute;
  right: 20px;
  top: 9px;
  width: 110px;
}

.main {
  background: url("../assets/background-login.jpg");
  background-size: cover;
  width: 100%;
  height: 100%;
}

.login-form {
  margin: 150px auto;
  padding: 42px 79px 59px 79px;
  background: #fff;
  display: block;
  width: 565px;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.welcome-text {
  text-align: center;
  font: normal normal normal 1em Calibri;
  color: #00475a;
  margin: 0px;
}

.pp > .theme--light.v-icon {
  color: #00475a;
}

p {
  padding: 0px;
  margin: 0px;
}

.v-btn {
  color: #fff;
}

a {
  color: #7b766a;
}
</style>
